import Cookies from 'js-cookie';
import { takeLatest, put, select } from 'redux-saga/effects';

import { api } from 'src/api';
import { dataLayerPush } from 'src/helpers/gtm';
import { currentUri } from 'src/utils/uriUtils';
import { getMobilePlatform } from '../view/selectors';

import {
  GO_MOBILE_APP_POPUP,
  PARTNER_KEY_COOKIE,
  MOVE_TO_APP_CONTINUED_WEB,
  MOVE_TO_APP_OPENED_APP,
  MOVE_TO_APP_SHOWN,
  GET_DEEPLINK,
  UTM_KEY_COOKIE,
  AFFMARKET_PARAMS,
  utm_marker,
} from './constants';
import { setMobileAppData, setShortLink } from './slice';

function* handleGoMobileApp() {
  const platform = yield select(getMobilePlatform);
  try {
    const response =
      platform === 'ios'
        ? yield api.getBannersIosAppData()
        : yield api.getBannersAndroidAppData();

    if (response) {
      yield put(setMobileAppData(response));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

function* handleGetDeeplink() {
  const partnerParamsUrl = new URLSearchParams(window.location.search);
  if (!partnerParamsUrl.has('aflt') && !partnerParamsUrl.has('affmarker')) {
    const cookieAfltValue = Cookies.get(PARTNER_KEY_COOKIE);
    if (cookieAfltValue) {
      const keyword = AFFMARKET_PARAMS;
      const decodedCookieValue = decodeURI(cookieAfltValue);
      const [affmarker] = decodedCookieValue
        .split(/[|&]/)
        .filter((item) => item.includes(keyword));
      if (affmarker) {
        const affmarkerValue = affmarker.match(/\d/g)?.join('');
        currentUri.addSearch(keyword, affmarkerValue);
      }
    }
  }
  // проверяем есть ли в урле обязательные utm-метки
  if (
    !partnerParamsUrl.has('utm_source') &&
    !partnerParamsUrl.has('utm_campaign') &&
    !partnerParamsUrl.has('utm_medium')
  ) {
    const cookieUtmValue = Cookies.get(UTM_KEY_COOKIE);
    if (cookieUtmValue) {
      // обязательный параметр
      const keyword = 'utmcsr';
      const decodedCookieValue = decodeURI(cookieUtmValue);
      const [utmz] = decodedCookieValue
        .split('.')
        .filter((item) => item.includes(keyword));
      utmz.split('|').forEach((marker) => {
        const utmValue = marker.split('=')[1];
        const utmParam = marker.split('=')[0];
        const utmMarker = utmParam && utm_marker.get(utmParam);
        if (utmValue !== '(direct)' && utmValue !== '(none)' && utmMarker)
          currentUri.addSearch(utmMarker, utmValue);
      });
    }
  }
  try {
    // ручка не умеет обрабатываеть стейджовые уры и dev
    const query = currentUri.search();
    const params = {
      link: `https://level.travel${encodeURI(
        window.location.pathname,
      )}${query}`,
    };
    const response = yield api.postBannersDeeplink(params);
    const { short_link } = response;
    yield put(setShortLink(short_link));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

// Analitics for banners
function isBannerShown() {
  dataLayerPush({
    event: 'move_to_app_shown',
  });
}

function onClickAppBanner() {
  dataLayerPush({
    event: 'move_to_app_opened_app',
  });
}

function onClickStayButton() {
  dataLayerPush({
    event: 'move_to_app_continued_web',
  });
}

export default function* appBannersSaga() {
  yield takeLatest(GO_MOBILE_APP_POPUP, handleGoMobileApp);
  yield takeLatest(GET_DEEPLINK, handleGetDeeplink);
  yield takeLatest(MOVE_TO_APP_OPENED_APP, onClickAppBanner);
  yield takeLatest(MOVE_TO_APP_CONTINUED_WEB, onClickStayButton);
  yield takeLatest(MOVE_TO_APP_SHOWN, isBannerShown);
}
